import { clientFor } from '@yc/api-client'

const api = clientFor('/wms/api')

/** 工作台 KPI：与后端 internal/home.Stats 的 JSON 字段一一对应 */
export interface HomeStats {
  /** 今天创建的入库单数 */
  today_asn: number
  /** 今天创建的出库单数 */
  today_order: number
  /** 还没拣的拣货任务数 */
  pending_tasks: number
  /** 当前有库存的商品数 */
  stock_skus: number
}

export const getHomeStats = (): Promise<HomeStats> => api.get<HomeStats>('/home/stats')
